import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getSchoolListApiCall = createAsyncThunk("SchoolList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: schoolList } = await API.getSchoolListApi(submitData);
        //  console.log("*********************************************",schoolList);
        dispatch(setLoader(false))
        return schoolList;
    } catch (error) {
        throw error;
    }
});

export const grantSchoolSubscriptionApiCall = createAsyncThunk("grantSchoolSubscription", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data, code, message } = await API.grantSchoolSubscriptionApi(submitData);
        dispatch(setLoader(false))
        return { data, code, message };
    } catch (error) {
        dispatch(setLoader(false))
        throw error;
    }
});

export const editSchoolDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editSchoolData, code, message } = await API.updateSchoolApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editSchoolData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    SchoolList: {
        data: [],
        error: null,
    },
    editSchoolData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const schoolSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSchoolListApiCall.fulfilled, (state, action) => {
                state.SchoolList.data = action.payload;
            })
            .addCase(getSchoolListApiCall.rejected, (state, action) => {
                state.SchoolList.error = action.error.message;
            })
            .addCase(editSchoolDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editSchoolData.data = data;
                state.editSchoolData.message = message;
                state.editSchoolData.code = code;
            })
            .addCase(editSchoolDataApiCall.rejected, (state, action) => {
                state.editSchoolData.error = action.error.message;
            });
    },
});

export default schoolSlice.reducer;